import { EntityType } from "../fields/metadata";

export class ConfigProvider {
    private static _config = new Map<string, any>();

    static get showAllSubEntities(): boolean { return this.get('config.showAllSubEntities') === "true"; }
    static set showAllSubEntities(value: boolean) { this.set('config.showAllSubEntities', value); }

    static get panelEntityType(): EntityType { return +this.get('config.panelEntityType') || EntityType.Undefined; }
    static set panelEntityType(value: EntityType) { this.set('config.panelEntityType', value); }


    private static get(key: string) {
        if (Office.context.partitionKey) {
            key = `${Office.context.partitionKey}.${key}`;
        }

        if (!this._config.has(key)) {
            this._config.set(key, localStorage.getItem(key) ?? null);
        }

        return this._config.get(key);
    }

    private static set(key: string, value: any) {
        if (Office.context.partitionKey) {
            key = `${Office.context.partitionKey}.${key}`;
        }

        value = value?.toString() ?? '';

        localStorage.setItem(key, value);
        this._config.set(key, value);

        return this._config.get(key);
    }
}